angular.module 'zc.users'

.factory 'Devise', ($q, $injector, $location, $translate, $window, $http, Api, returnUrl) ->

  service =
    currentUser: undefined

    signIn: (email, password, remember_me) ->
      Api.post '/users/sign_in',
        user:
          email: email
          password: password
          remember_me: remember_me
      .then (res) ->
        if res.data.success
          $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken
          service.currentUser = res.data.user
          service.currentUser
        else
          alertify.error $translate.instant('users.services.deviseService.loginError'), 0
          $q.reject res

    signOut: ->
      if $window.ZC_CONFIG.ENABLE_AUTH0
        service.currentUser = null
        $window.location.href = "#{Api.basePath}/users/auth/logout?origin=#{$window.location.origin}/users/sign_in";
      else
        Api.delete '/users/sign_out'
        .then (res) ->
          $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken
          service.currentUser = null
          $window.location = '/users/sign_in'

    updateInfo: (user) ->
      Api.patch "/api/users/update_info",
        user
      .then (res) ->
        $translate.use(res.data.user.lang)
        moment.locale(res.data.user.lang)
        # Ideally would like to do _.merge, but for some reason, after first
        # login, we get login_token null response, which is bad.
        # (although currentUser already has the proper login_token from sign_in)
        # Does not happen locally but only in staging!! (and likely in
        # production)
        safeData = _.omit res.data.user, ['login_token']
        service.currentUser = _.merge service.currentUser, safeData
        service.currentUser

    password: (email) ->
      # workaround to show loading spinner without wait
      NotificationChannel = $injector.get("NotificationChannel")
      NotificationChannel.requestStarted()
      d = $q.defer()
      Api.post '/users/password',
        user:
          email: email
        locale: $translate.use()
      .then (res) ->
        service.currentUser = res.data.user
        d.resolve service.currentUser
      d.promise

    resetPassword: (reset_password_token, password, password_confirmation) ->
      Api.put '/users/password',
        user:
          password: password
          password_confirmation: password_confirmation
          reset_password_token: reset_password_token
        locale: $translate.use()
      .then (res) ->
        service.currentUser = res.data.user
        service.currentUser


    updatePassword: (current_password, password, password_confirmation) ->
      # workaround to show loading spinner without wait
      NotificationChannel = $injector.get("NotificationChannel")
      NotificationChannel.requestStarted()
      d = $q.defer()
      Api.patch "/api/users/update_password",
        user:
          current_password: current_password
          password: password
          password_confirmation: password_confirmation
      .then (res) ->
        service.currentUser = res.data.user
        d.resolve service.currentUser
      , (res) ->
        err_cnt = _.reduce res.data.errors, (cnt, errors) ->
          cnt + errors.length
        , 0
        # TODO: Move to directives
        alertify.error $translate.instant('users.services.deviseService.incorrectPassword') if err_cnt is 0
        d.reject res
      d.promise

    validateInvitationToken: (invitation_token) ->
      Api.get "/users/invitation/accept?invitation_token=#{invitation_token}"
      .then (res) ->
        res.data.user.invitation_token = invitation_token if res.data
        res.data?.user

    accept: (user) ->
      Api.patch "/users/invitation",
        user:
          full_name: user.full_name
          email: user.email
          password: user.password
          password_confirmation: user.password_confirmation
          invitation_token: user.invitation_token
          lang: user.lang
        locale: user.lang
      .then (res) ->
        service.signIn(user.email, user.password, true)

    invite: (email) ->
      # workaround to show loading spinner without wait
      NotificationChannel = $injector.get("NotificationChannel")
      NotificationChannel.requestStarted()
      d = $q.defer()
      Api.post '/users/invitation', email
      .then (res) ->
        d.resolve res.result
      d.promise

    become: (user) ->
      Api.post "/api/master/users/#{user.id}/become"
      .then (res) ->
        if res.data.success
          # forward to sign in and force reload
          $window.location = '/users/sign_in'

    getCurrentUserLanguage: () ->
      return $q.when(service.currentUser.lang) if service.isAuthenticated()
      return Api.get('/users/show_current', {}).then (res) ->
        _.get(res, 'data.user.lang')

    getCurrentUser: (opts = {}) ->
      if service.isAuthenticated() && !opts.force
        $q.when service.currentUser
      else
        if opts.force
          promise = Api.get "/users/show_current", {}, { cache: false, isPreflight: opts.isPreflight }
        else
          promise = Api.get("/users/show_current", {}, { isPreflight: opts.isPreflight})

        promise.then (res) ->
          if !res.data.success
            if $window.ZC_CONFIG.ENABLE_AUTH0
              $window.location.href = "#{Api.basePath}/users/auth/login?origin=#{$window.location.href}";
              return
            unless $location.path() == "/users/sign_in" or $location.path() == "/users/password/new"
              returnUrl.set($location.path())
              $location.path("/users/sign_in")
            $q.reject null
          else
            $translate.use(res.data.user.lang)

            $http.defaults.headers.common['X-CSRF-TOKEN'] = res.data.csrfToken
            service.currentUser = res.data.user
            res.data.user
        .catch (err) ->
          $q.reject null

    isAuthenticated: ->
      !!service.currentUser

    isCommonUser: ->
      service.currentUser?.role is 'common'

    isMaster: ->
      service.currentUser?.role is 'master'

    isInternalUser: ->
      service.currentUser?.role is 'internal'

    signAgreements: (user) ->
      Api.patch "/api/users/#{user.id}/sign_agreements"
      .then (res) ->
        # Ideally would like to do _.merge, but we update only the agreement_signed_at,
        # because for some reason, at this point login_token is null in response
        # (although currentUser already has the proper login_token one)
        # Does not happen locally but only in staging!! (and likely in
        # production)
        safeData = _.omit(res.data.user, ['login_token'])
        service.currentUser = _.merge(service.currentUser, safeData)
        service.currentUser

  service



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/users/services/devise_service.js.coffee